export default __webpack_public_path__ + "static/2-3d5840093ecc700e68038811ca794e7a.jpg";